export const emptyValidator = () => ({
  func: (val) =>
    val === undefined ||
    val === null ||
    (typeof val === "string" && val.trim() === "") ||
    (typeof val === "object" &&
      val !== null &&
      !Array.isArray(val) &&
      Object.keys(val).length === 0) ||
    (Array.isArray(val) && val.length === 0),
  message: (name) => `${name} is required`,
});

export const decimalNumberValidator = () => (value) => {
  if (value === "" || value === null || value === undefined) {
    return "Unit Price cannot be empty";
  }
  if (!/^\d+(\.\d{1,2})?$/.test(value)) {
    return "Invalid number format. Use up to 2 decimal places.";
  }
  return null;
};

export const arrayNotEmptyValidator = () => ({
  func: (val) => Array.isArray(val) && val.length === 0,
  message: (name) => `At least one ${name} is required`,
});

export const dateValidator = () => ({
  func: (val) => {
    // if (typeof val !== "string" || val.trim() === "") {
    //   return true; // Allow empty values
    // }
    // Check if the input string matches the "YYYY-MM-DD" format
    const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
    if (!dateRegex.test(val)) {
      return true; // Return true for invalid format
    }
    // Parse the input string into a Date object and check if it's a valid date
    const parsedDate = new Date(val);
    return isNaN(parsedDate);
  },
  message: (name) => `${name} is not a valid date or is required`,
});

export const vehicleNoValidator = () => ({
  func: (val) => {
    const vehNoRegex = /^[A-Z0-9]([A-Z0-9-]{2,}[A-Z0-9])$/;
    return !vehNoRegex.test(val);
  },
  message: (name) => `Invalid ${name}`,
});

export const dateTimeValidator = () => ({
  func: (val) => {
    // Check if the input string matches the "MM/DD/YYYY HH:mm AM/PM" format
    const dateTimeRegex =
      /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{4} (0[0-9]|1[0-2]):([0-5][0-9]) (AM|PM)$/;

    if (!dateTimeRegex.test(val)) {
      return true; // Return true for invalid format
    }

    // Convert 12-hour AM/PM format to 24-hour format for parsing
    let [datePart, timePart, meridian] = val.split(" ");
    let [hours, minutes] = timePart.split(":");
    if (meridian === "PM" && hours !== "12") {
      hours = parseInt(hours, 10) + 12; // Convert PM hours to 24-hour format, except for 12 PM
    } else if (meridian === "AM" && hours === "12") {
      hours = "00"; // Convert 12 AM to 00 hours
    }
    let formattedDateTime = `${datePart} ${hours}:${minutes}`;

    // Parse the input string into a Date object and check if it's a valid date and time
    const parsedDateTime = new Date(formattedDateTime);

    return isNaN(parsedDateTime); // Return true if the date-time is invalid
  },
  message: (name) => `${name} is not a valid date and time or is required`,
});

export const numberReangeValidator = function (num) {
  return {
    num,
    func: function (val) {
      return val < this.num;
    },
    message: function (name) {
      return `${name} should be greater than ${this.num}`;
    },
  };
};

export const greaterThanZeroValidator = function () {
  return {
    func: function (val) {
      const number = parseFloat(val);
      return !isNaN(number) && isFinite(number) && number < 0;
    },
    message: function (name) {
      return `${name} must be a number greater than 0`;
    },
  };
};

export const dateMustBeTodayValidator = function () {
  return {
    func: function (val) {
      const inputDate = new Date(val);
      const today = new Date();
      // Reset hours, minutes, seconds, and milliseconds for both dates
      inputDate.setHours(0, 0, 0, 0);
      today.setHours(0, 0, 0, 0);
      return inputDate.getTime() !== today.getTime();
    },
    message: (name) => `${name} must be today's date`,
  };
};

export const dateMustBeGreaterThanTodayValidator = function () {
  return {
    func: function (val) {
      const inputDate = new Date(val);
      const today = new Date();
      // Reset hours, minutes, seconds, and milliseconds for both dates
      inputDate.setHours(0, 0, 0, 0);
      today.setHours(0, 0, 0, 0);
      return inputDate < today;
    },
    message: (name) => `${name} must be greater than today's date`,
  };
};

export const dateMustBeGreaterThanTodayNMValidator = function () {
  return {
    func: function (val) {
      if (!val) {
        return false;
      }
      const inputDate = new Date(val);
      const today = new Date();
      // Reset hours, minutes, seconds, and milliseconds for both dates
      inputDate.setHours(0, 0, 0, 0);
      today.setHours(0, 0, 0, 0);
      return inputDate < today;
    },
    message: (name) => `${name} must be greater than today's date`,
  };
};

export const dateMustBeLessThanTodayValidator = function () {
  return {
    func: function (val) {
      const inputDate = new Date(val);
      const today = new Date();
      // Reset hours, minutes, seconds, and milliseconds for both dates
      inputDate.setHours(0, 0, 0, 0);
      today.setHours(0, 0, 0, 0);
      return inputDate > today;
    },
    message: (name) => `${name} must be greater than today's date`,
  };
};

export const yearMustBeLessThanCurrentValidator = function () {
  return {
    func: function (val) {
      const inputYear = new Date(val).getFullYear(); // Extract the year from the input value
      const currentYear = new Date().getFullYear(); // Get the current year
      return inputYear > currentYear; // Check if the input year is less than the current year
    },
    message: (name) => `${name} must be less than the current year`,
  };
};

export const mobilePhoneMenValidator = function () {
  return {
    func: function (val) {
      const isNumericAndCorrectLength = /^\d{10,12}$/.test(val);
      return !isNumericAndCorrectLength;
    },
    message: (name) =>
      `${name} must be a number between 10 and 12 digits without any spaces`,
  };
};

export const mobilePhoneNotMenValidator = function () {
  return {
    func: function (val) {
      if (val === null || (typeof val === "string" && val.trim() === "")) {
        return false;
      }
      const isNumericAndCorrectLength = /^\d{10,12}$/.test(val);
      return !isNumericAndCorrectLength;
    },
    message: (name) =>
      `${name} must be a number between 10 and 12 digits without any spaces`,
  };
};

export const commaSpaceValidator = () => {
  return {
    func: function (str) {
      const pattern = /, /; // Pattern for ", "
      return !pattern.test(str); // Returns true if ", " is found
    },
    message: (name) => `${name} must contain ", "`,
  };
};

export const emailMenValidator = () => {
  return {
    func: function (email) {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return !emailPattern.test(email);
    },
    message: (name) => `${name} must be a valid email address`,
  };
};

export const emailNotMenValidator = () => {
  return {
    func: function (email) {
      if (
        email === null ||
        (typeof email === "string" && email.trim() === "")
      ) {
        return false;
      }

      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return !emailPattern.test(email);
    },
    message: (name) => `${name} must be a valid email address`,
  };
};

export const formValidator = (data, validationData) => {
  const errors = {};
  Object.keys(data).forEach((key) => {
    const value = data[key];
    const validation = validationData?.[key];
    if (validation) {
      for (let validator of validation.validators) {
        if (validator.func(value)) {
          errors[key] = validator.message(validation.name);
          break;
        }
      }
    }
  });

  return errors;
};

export const nicValidator = () => ({
  func: (val) => {
    const oldNicRegex = /^\d{9}[vV]$/;
    const newNicRegex = /^\d{12}$/;

    return !(oldNicRegex.test(val) || newNicRegex.test(val));
  },
  message: (name) =>
    `${name} must be either 9 digits followed by 'V' or exactly 12 digits`,
});

export const nicNonMandatoryValidator = () => ({
  func: (val) => {
    if (val === null || (typeof val === "string" && val.trim() === "")) {
      return false;
    }

    const oldNicRegex = /^\d{9}[vV]$/;
    const newNicRegex = /^\d{12}$/;

    return !(oldNicRegex.test(val) || newNicRegex.test(val));
  },
  message: (name) =>
    `${name} must be either 9 digits followed by 'V' or exactly 12 digits`,
});

export const duplicateVehicleTypeValidator = (
  currentList,
  newType,
  currentId,
) => {
  return currentList.some(
    (type) => type.vetType === newType && type.id !== currentId,
  );
};

export const numberOnlyValidator = () => ({
  func: (val) => {
    if (val === null || val === undefined || val === "") return false;
    return isNaN(val);
  },
  message: (name) => `${name} must be a valid number`,
});

export const bankNameValidator = () => ({
  func: (val) => {
    if (val === null || val === undefined || val === "") return false;
    const bankNameRegex = /^[a-zA-Z\s&_\-()]+$/;
    return !bankNameRegex.test(val);
  },
  message: (name) =>
    `${name} cannot contain numbers or special characters except &, -, _, (, )`,
});

export const nameValidator = () => ({
  func: (val) => {
    if (val === null || val === undefined || (typeof val === "string" && val.trim() === "")) return false;
    const nameRegex = /^[a-zA-Z\s.'-]+$/;
    return !nameRegex.test(val);
  },
  message: () => "Please enter a valid name.",
});



